export default "/img/SG.b941c81b7169dd9a1d4ec68ba658309e.png";